export var CommonServiceApiTags;
(function (CommonServiceApiTags) {
    CommonServiceApiTags["Customization"] = "Customization";
    CommonServiceApiTags["Profile"] = "Profile";
    CommonServiceApiTags["SupervisorOnboarding"] = "SupervisorOnboarding";
    CommonServiceApiTags["BalanceAndNotifications"] = "BalanceAndNotifications";
    CommonServiceApiTags["ShowBalance"] = "ShowThankBalance";
    CommonServiceApiTags["ComplianceDate"] = "ComplianceDate";
    CommonServiceApiTags["Conversion"] = "Conversion";
    CommonServiceApiTags["BenefitCompanyBalance"] = "BenefitCompanyBalance";
    CommonServiceApiTags["BenefitConversion"] = "BenefitConversion";
    CommonServiceApiTags["AdditionalInfo"] = "AdditionalInfo";
    CommonServiceApiTags["SupportRequestTypes"] = "SupportRequestTypes";
    CommonServiceApiTags["NotificationDrawer"] = "NotificationDrawer";
    CommonServiceApiTags["ChatUnread"] = "ChatUnread";
})(CommonServiceApiTags || (CommonServiceApiTags = {}));
